const badge = {

}

badge.sort = [
    {
        en: "Bulbasaur",
        zh: "妙蛙种子",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpAttack":"1.8"
            },
            Silver: {
                "HP": "-40",
                "SpAttack":"2.4"
            },
            Gold: {
                "HP": "-50",
                "SpAttack":"3"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color: ['green']
    },
    {
        en: "Ivysaur",
        zh: "妙蛙草",
        attr: {
            Bronze: {
                "Defense": "-3",
                "SpAttack":"1.8"
            },
            Silver: {
                "Defense": "-4",
                "SpAttack":"2.4"
            },
            Gold: {
                "Defense": "-5",
                "SpAttack":"3"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Venusaur",
        zh: "妙蛙花",
        attr: {
            Bronze: {
                "Attack": "-1.2",
                "SpAttack":"1.8"
            },
            Silver: {
                "Attack": "-1.6",
                "SpAttack":"2.4"
            },
            Gold: {
                "Attack": "-2",
                "SpAttack":"3"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Charmander",
        zh: "小火龙",
        attr: {
            Bronze: {
                "HP": "30",
                "Attack":"-1.2"
            },
            Silver: {
                "HP": "40",
                "Attack":"-1.6"
            },
            Gold: {
                "HP": "50",
                "Attack":"-2"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['red']
    },
    {
        en: "Charmeleon",
        zh: "火恐龙",
        attr: {
            Bronze: {
                "HP": "30",
                "SpDefense":"-3"
            },
            Silver: {
                "HP": "40",
                "SpDefense":"-4"
            },
            Gold: {
                "HP": "50",
                "SpDefense":"-5"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['red']
    },
    {
        en: "Charizard",
        zh: "喷火龙",
        attr: {
            Bronze: {
                "HP": "30",
                "Defense":"-3"
            },
            Silver: {
                "HP": "40",
                "Defense":"-4"
            },
            Gold: {
                "HP": "50",
                "Defense":"-5"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['red']
    },
    {
        en: "Squirtle",
        zh: "杰尼龟",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpAttack":"1.8"
            },
            Silver: {
                "HP": "-40",
                "SpAttack":"2.4"
            },
            Gold: {
                "HP": "-50",
                "SpAttack":"3"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Wartortle",
        zh: "卡咪龟",
        attr: {
            Bronze: {
                "Defense": "-3",
                "SpAttack":"1.8"
            },
            Silver: {
                "Defense": "-4",
                "SpAttack":"2.4"
            },
            Gold: {
                "Defense": "-5",
                "SpAttack":"3"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Blastoise",
        zh: "水箭龟",
        attr: {
            Bronze: {
                "CriticalRate": "-0.3",
                "SpAttack":"1.8"
            },
            Silver: {
                "CriticalRate": "-0.5",
                "SpAttack":"2.4"
            },
            Gold: {
                "CriticalRate": "-0.6",
                "SpAttack":"3"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Caterpie",
        zh: "绿毛虫",
        attr: {
            Bronze: {
                "HP": "-30",
                "Defense":"3"
            },
            Silver: {
                "HP": "-40",
                "Defense":"4"
            },
            Gold: {
                "HP": "-50",
                "Defense":"5"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Metapod",
        zh: "铁甲蛹",
        attr: {
            Bronze: {
                "Defense": "3",
                "Speed":"-21"
            },
            Silver: {
                "Defense": "4",
                "Speed":"-28"
            },
            Gold: {
                "Defense": "5",
                "Speed":"-35"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Butterfree",
        zh: "巴大蝶",
        attr: {
            Bronze: {
                "Attack": "-1.2",
                "Defense":"3.0"
            },
            Silver: {
                "Attack": "-1.6",
                "Defense":"4"
            },
            Gold: {
                "Attack": "-2",
                "Defense":"5"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green','white']
    },
    {
        en: "Weedle",
        zh: "独角虫",
        attr: {
            Bronze: {
                "SpDefense": "3",
                "Defense":"-3"
            },
            Silver: {
                "SpDefense": "4",
                "Defense":"-4"
            },
            Gold: {
                "SpDefense": "5",
                "Defense":"-5"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Kakuna",
        zh: "铁壳蛹",
        attr: {
            Bronze: {
                "Speed": "-21",
                "SpDefense":"3.0"
            },
            Silver: {
                "Speed": "-28",
                "SpDefense":"4"
            },
            Gold: {
                "Speed": "-35",
                "SpDefense":"5"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Beedrill",
        zh: "大针蜂",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpDefense":"3.0"
            },
            Silver: {
                "HP": "-40",
                "SpDefense":"4"
            },
            Gold: {
                "HP": "-50",
                "SpDefense":"5"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green','black']
    },
    {
        en: "Pidgey",
        zh: "波波",
        attr: {
            Bronze: {
                "HP": "30",
                "Defense":"-3"
            },
            Silver: {
                "HP": "40",
                "Defense":"-4"
            },
            Gold: {
                "HP": "50",
                "Defense":"-5"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Pidgeotto",
        zh: "比比鸟",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpDefense":"3.0"
            },
            Silver: {
                "HP": "-40",
                "SpDefense":"4"
            },
            Gold: {
                "HP": "-50",
                "SpDefense":"5"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Pidgeot",
        zh: "大比鸟",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpDefense":"3.0"
            },
            Silver: {
                "HP": "-40",
                "SpDefense":"4"
            },
            Gold: {
                "HP": "-50",
                "SpDefense":"5"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Rattata",
        zh: "小拉达",
        attr: {
            Bronze: {
                "HP": "-30",
                "Defense":"3"
            },
            Silver: {
                "HP": "-40",
                "Defense":"4"
            },
            Gold: {
                "HP": "-50",
                "Defense":"5"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Raticate",
        zh: "拉达",
        attr: {
            Bronze: {
                "SpAttack": "-1.8",
                "Defense":"3"
            },
            Silver: {
                "SpAttack": "-2.4",
                "Defense":"4"
            },
            Gold: {
                "SpAttack": "-3",
                "Defense":"5"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Spearow",
        zh: "烈雀",
        attr: {
            Bronze: {
                "Attack": "1.2",
                "SpDefense":"-3"
            },
            Silver: {
                "Attack": "1.6",
                "SpDefense":"-4"
            },
            Gold: {
                "Attack": "2",
                "SpDefense":"-5"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Fearow",
        zh: "大嘴雀",
        attr: {
            Bronze: {
                "Attack": "1.2",
                "SpAttack": "-1.8"
            },
            Silver: {
                "Attack": "1.6",
                "SpAttack":"-2.4"
            },
            Gold: {
                "Attack": "2",
                "SpAttack":"-3"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Ekans",
        zh: "阿伯蛇",
        attr: {
            Bronze: {
                "Attack": "1.2",
                "Defense":"-3"
            },
            Silver: {
                "Attack": "1.6",
                "Defense":"4"
            },
            Gold: {
                "Attack": "2",
                "Defense":"5"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['black']
    },
    {
        en: "Arbok",
        zh: "阿伯怪",
        attr: {
            Bronze: {
                "Attack": "1.2",
                "SpDefense":"-3"
            },
            Silver: {
                "Attack": "1.6",
                "SpDefense":"-4"
            },
            Gold: {
                "Attack": "2",
                "SpDefense":"-5"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['black']
    },
    {
        en: "Pikachu",
        zh: "皮卡丘",
        attr: {
            Bronze: {
                "CriticalRate": "-0.3",
                "SpDefense":"3"
            },
            Silver: {
                "CriticalRate": "-0.5",
                "SpDefense":"4"
            },
            Gold: {
                "CriticalRate": "-0.6",
                "SpDefense":"5"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['yellow']
    },
    {
        en: "Raichu",
        zh: "雷丘",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpDefense":"3"
            },
            Silver: {
                "HP": "-40",
                "SpDefense":"4"
            },
            Gold: {
                "HP": "-50",
                "SpDefense":"5"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['yellow']
    },
    {
        en: "Sandshrew",
        zh: "穿山鼠",
        attr: {
            Bronze: {
                "SpDefense": "-3.0",
                "CriticalRate":"0.3"
            },
            Silver: {
                "SpDefense": "-4.0",
                "CriticalRate":"0.5"
            },
            Gold: {
                "SpDefense": "-5.0",
                "CriticalRate":"0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Sandslash",
        zh: "穿山王",
        attr: {
            Bronze: {
                "SpAttack": "-1.8",
                "CriticalRate":"0.3"
            },
            Silver: {
                "SpAttack": "-2.4",
                "CriticalRate":"0.5"
            },
            Gold: {
                "SpAttack": "-3.0",
                "CriticalRate":"0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Nidoran_F",
        zh: "尼多兰",
        attr: {
            Bronze: {
                "HP": "30",
                "SpDefense":"-3.0"
            },
            Silver: {
                "HP": "40",
                "SpDefense":"-4.0"
            },
            Gold: {
                "HP": "50",
                "SpDefense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple']
    },
    {
        en: "Nidorina",
        zh: "尼多娜",
        attr: {
            Bronze: {
                "HP": "30",
                "Defense":"-3.0"
            },
            Silver: {
                "HP": "40",
                "Defense":"-4.0"
            },
            Gold: {
                "HP": "50",
                "Defense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple']
    },
    {
        en: "Nidoqueen",
        zh: "尼多后",
        attr: {
            Bronze: {
                "HP": "30",
                "SpAttack":"-1.8"
            },
            Silver: {
                "HP": "40",
                "SpAttack":"-2.4"
            },
            Gold: {
                "HP": "50",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown','purple']
    },
    {
        en: "Nidoran_M",
        zh: "尼多朗",
        attr: {
            Bronze: {
                "HP": "-30",
                "Attack":"1.2"
            },
            Silver: {
                "HP": "-40",
                "Attack":"1.6"
            },
            Gold: {
                "HP": "-50",
                "Attack":"2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple']
    },
    {
        en: "Nidorino",
        zh: "尼多力诺",
        attr: {
            Bronze: {
                "Attack": "1.2",
                "SpDefense":"-3.0"
            },
            Silver: {
                "Attack": "1.6",
                "SpDefense":"-4.0"
            },
            Gold: {
                "Attack": "2.0",
                "SpDefense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple']
    },
    {
        en: "Nidoking",
        zh: "尼多王",
        attr: {
            Bronze: {
                "Attack": "1.2",
                "Defense":"-3.0"
            },
            Silver: {
                "Attack": "1.6",
                "Defense":"-4.0"
            },
            Gold: {
                "Attack": "2.0",
                "Defense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown','purple']
    },
    {
        en: "Clefairy",
        zh: "皮皮",
        attr: {
            Bronze: {
                "HP": "30",
                "Defense":"-3.0"
            },
            Silver: {
                "HP": "40",
                "Defense":"-4.0"
            },
            Gold: {
                "HP": "50",
                "Defense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['pink']
    },
    {
        en: "Clefable",
        zh: "皮可西",
        attr: {
            Bronze: {
                "HP": "30",
                "Speed":"-21.0"
            },
            Silver: {
                "HP": "40",
                "Speed":"-28.0"
            },
            Gold: {
                "HP": "50",
                "Speed":"-35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['pink']
    },
    {
        en: "Vulpix",
        zh: "六尾",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpDefense":"3.0"
            },
            Silver: {
                "HP": "-40",
                "SpDefense":"4"
            },
            Gold: {
                "HP": "-50",
                "SpDefense":"5"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['red']
    },
    {
        en: "Ninetales",
        zh: "九尾",
        attr: {
            Bronze: {
                "Attack": "-1.2",
                "SpDefense":"3.0"
            },
            Silver: {
                "Attack": "-1.6",
                "SpDefense":"4.0"
            },
            Gold: {
                "Attack": "-2.0",
                "SpDefense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['red']
    },
    {
        en: "Jigglypuff",
        zh: "胖丁",
        attr: {
            Bronze: {
                "HP": "30",
                "SpDefense":"-3.0"
            },
            Silver: {
                "HP": "40",
                "SpDefense":"-4.0"
            },
            Gold: {
                "HP": "50",
                "SpDefense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['pink']
    },
    {
        en: "Wigglytuff",
        zh: "胖可丁",
        attr: {
            Bronze: {
                "HP": "30",
                "Speed":"-21.0"
            },
            Silver: {
                "HP": "40",
                "Speed":"-28.0"
            },
            Gold: {
                "HP": "50",
                "Speed":"-35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['pink']
    },
    {
        en: "Zubat",
        zh: "超音蝠",
        attr: {
            Bronze: {
                "Attack": "-1.2",
                "Speed":"21.0"
            },
            Silver: {
                "Attack": "-1.6",
                "Speed":"28.0"
            },
            Gold: {
                "Attack": "-2.0",
                "Speed":"35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['black']
    },
    {
        en: "Golbat",
        zh: "大嘴蝠",
        attr: {
            Bronze: {
                "Speed": "21.0",
                "SpDefense":"-3.0"
            },
            Silver: {
                "Speed": "28.0",
                "SpDefense":"-4.0"
            },
            Gold: {
                "Speed": "35.0",
                "SpDefense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['black']
    },
    {
        en: "Oddish",
        zh: "走路草",
        attr: {
            Bronze: {
                "HP": "30",
                "Speed":"-21.0"
            },
            Silver: {
                "HP": "40",
                "Speed":"-28.0"
            },
            Gold: {
                "HP": "50",
                "Speed":"-35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Gloom",
        zh: "臭臭花",
        attr: {
            Bronze: {
                "HP": "30",
                "Defense":"-3.0"
            },
            Silver: {
                "HP": "40",
                "Defense":"-4.0"
            },
            Gold: {
                "HP": "50",
                "Defense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Vileplume",
        zh: "霸王花",
        attr: {
            Bronze: {
                "HP": "30",
                "Attack":"-1.2"
            },
            Silver: {
                "HP": "40",
                "Attack":"-1.6"
            },
            Gold: {
                "HP": "50",
                "Attack":"-2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['black','green']
    },
    {
        en: "Paras",
        zh: "派拉斯",
        attr: {
            Bronze: {
                "Defense": "3.0",
                "CriticalRate":"-0.3"
            },
            Silver: {
                "Defense": "4.0",
                "CriticalRate":"-0.5"
            },
            Gold: {
                "Defense": "5.0",
                "CriticalRate":"-0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Parasect",
        zh: "派拉斯特",
        attr: {
            Bronze: {
                "Defense": "3.0",
                "SpAttack":"-1.8"
            },
            Silver: {
                "Defense": "4.0",
                "SpAttack":"-2.4"
            },
            Gold: {
                "Defense": "5.0",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Venonat",
        zh: "毛球",
        attr: {
            Bronze: {
                "HP": "30",
                "Attack":"-1.2"
            },
            Silver: {
                "HP": "40",
                "Attack":"-1.6"
            },
            Gold: {
                "HP": "50",
                "Attack":"-2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Venomoth",
        zh: "摩鲁蛾",
        attr: {
            Bronze: {
                "HP": "30",
                "CriticalRate":"-0.3"
            },
            Silver: {
                "HP": "40",
                "CriticalRate":"-0.5"
            },
            Gold: {
                "HP": "50",
                "CriticalRate":"-0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green','black']
    },
    {
        en: "Diglett",
        zh: "地鼠",
        attr: {
            Bronze: {
                "HP": "-30",
                "Speed":"21.0"
            },
            Silver: {
                "HP": "-40",
                "Speed":"28.0"
            },
            Gold: {
                "HP": "-50",
                "Speed":"35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Dugtrio",
        zh: "三地鼠",
        attr: {
            Bronze: {
                "Speed": "21.0",
                "Defense":"-3.0"
            },
            Silver: {
                "Speed": "28.0",
                "Defense":"-4.0"
            },
            Gold: {
                "Speed": "35.0",
                "Defense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Meowth",
        zh: "喵喵",
        attr: {
            Bronze: {
                "Defense": "-3.0",
                "CriticalRate":"0.3"
            },
            Silver: {
                "Defense": "-4.0",
                "CriticalRate":"0.5"
            },
            Gold: {
                "Defense": "-5.0",
                "CriticalRate":"0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Persian",
        zh: "猫老大",
        attr: {
            Bronze: {
                "Defense": "-3.0",
                "CriticalRate":"0.3"
            },
            Silver: {
                "Defense": "-4.0",
                "CriticalRate":"0.5"
            },
            Gold: {
                "Defense": "-5.0",
                "CriticalRate":"0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Psyduck",
        zh: "可达鸭",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpDefense":"3.0"
            },
            Silver: {
                "HP": "-40",
                "SpDefense":"4.0"
            },
            Gold: {
                "HP": "-50",
                "SpDefense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },  
    {
        en: "Golduck",
        zh: "哥达鸭",
        attr: {
            Bronze: {
                "Attack": "-1.2",
                "SpDefense":"3.0"
            },
            Silver: {
                "Attack": "-1.6",
                "SpDefense":"4.0"
            },
            Gold: {
                "Attack": "-2.0",
                "SpDefense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Mankey",
        zh: "猴怪",
        attr: {
            Bronze: {
                "HP": "30",
                "Defense":"-3.0"
            },
            Silver: {
                "HP": "40",
                "Defense":"-4.0"
            },
            Gold: {
                "HP": "50",
                "Defense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Primeape",
        zh: "火爆猴",
        attr: {
            Bronze: {
                "HP": "30",
                "SpAttack":"-1.8"
            },
            Silver: {
                "HP": "40",
                "SpAttack":"-2.4"
            },
            Gold: {
                "HP": "50",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Growlithe",
        zh: "卡蒂狗",
        attr: {
            Bronze: {
                "SpAttack": "1.8",
                "SpDefense":"-3.0"
            },
            Silver: {
                "SpAttack": "2.4",
                "SpDefense":"-4.0"
            },
            Gold: {
                "SpAttack": "3.0",
                "SpDefense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['red']
    },
    {
        en: "Arcanine",
        zh: "风速狗",
        attr: {
            Bronze: {
                "Attack": "-1.2",
                "SpAttack":"1.8"
            },
            Silver: {
                "Attack": "-1.6",
                "SpAttack":"2.4"
            },
            Gold: {
                "Attack": "-2.0",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['red']
    },
    {
        en: "Poliwag",
        zh: "蚊香蝌蚪",
        attr: {
            Bronze: {
                "Defense": "-3.0",
                "SpDefense":"3.0"
            },
            Silver: {
                "Defense": "-4.0",
                "SpDefense":"4.0"
            },
            Gold: {
                "Defense": "-5.0",
                "SpDefense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Poliwhirl",
        zh: "蚊香君",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpDefense":"3.0"
            },
            Silver: {
                "HP": "-40",
                "SpDefense":"4.0"
            },
            Gold: {
                "HP": "-50",
                "SpDefense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Poliwrath",
        zh: "蚊香泳士",
        attr: {
            Bronze: {
                "SpAttack": "-1.8",
                "SpDefense":"3.0"
            },
            Silver: {
                "SpAttack": "-2.4",
                "SpDefense":"4.0"
            },
            Gold: {
                "SpAttack": "-3.0",
                "SpDefense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown','blue']
    },
    {
        en: "Abra",
        zh: "凯西",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpAttack":"1.8"
            },
            Silver: {
                "HP": "-40",
                "SpAttack":"2.4"
            },
            Gold: {
                "HP": "-50",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple']
    },
    {
        en: "Kadabra",
        zh: "勇基拉",
        attr: {
            Bronze: {
                "SpAttack": "1.8",
                "CriticalRate":"-0.3"
            },
            Silver: {
                "SpAttack": "2.4",
                "CriticalRate":"-0.5"
            },
            Gold: {
                "SpAttack": "3.0",
                "CriticalRate":"-0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple']
    },
    {
        en: "Alakazam",
        zh: "胡地",
        attr: {
            Bronze: {
                "Attack": "-1.2",
                "SpAttack":"1.8"
            },
            Silver: {
                "Attack": "-1.6",
                "SpAttack":"2.4"
            },
            Gold: {
                "Attack": "-2.0",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple']
    },
    {
        en: "Machop",
        zh: "腕力",
        attr: {
            Bronze: {
                "Attack": "1.2",
                "Speed":"-21.0"
            },
            Silver: {
                "Attack": "1.6",
                "Speed":"-28.0"
            },
            Gold: {
                "Attack": "2.0",
                "Speed":"-35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Machoke",
        zh: "豪力",
        attr: {
            Bronze: {
                "Attack": "1.2",
                "SpDefense":"-3.0"
            },
            Silver: {
                "Attack": "1.6",
                "SpDefense":"-4.0"
            },
            Gold: {
                "Attack": "2.0",
                "SpDefense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Machamp",
        zh: "怪力",
        attr: {
            Bronze: {
                "Attack": "1.2",
                "SpAttack":"-1.8"
            },
            Silver: {
                "Attack": "1.6",
                "SpAttack":"-2.4"
            },
            Gold: {
                "Attack": "2.0",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Bellsprout",
        zh: "喇叭芽",
        attr: {
            Bronze: {
                "Attack": "1.2",
                "Defense":"-3.0"
            },
            Silver: {
                "Attack": "1.6",
                "Defense":"-4.0"
            },
            Gold: {
                "Attack": "2.0",
                "Defense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Weepinbell",
        zh: "口呆花",
        attr: {
            Bronze: {
                "HP": "-30",
                "Attack":"1.2"
            },
            Silver: {
                "HP": "-40",
                "Attack":"1.6"
            },
            Gold: {
                "HP": "-50",
                "Attack":"2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Victreebel",
        zh: "大食花",
        attr: {
            Bronze: {
                "Attack": "1.2",
                "SpDefense":"-3.0"
            },
            Silver: {
                "Attack": "1.6",
                "SpDefense":"-4.0"
            },
            Gold: {
                "Attack": "2.0",
                "SpDefense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['black','green']
    },
    {
        en: "Tentacool",
        zh: "玛瑙水母",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpDefense":"3.0"
            },
            Silver: {
                "HP": "-40",
                "SpDefense":"4.0"
            },
            Gold: {
                "HP": "-50",
                "SpDefense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Tentacruel",
        zh: "毒刺水母",
        attr: {
            Bronze: {
                "SpDefense": "3.0",
                "CriticalRate":"-0.3"
            },
            Silver: {
                "SpDefense": "4.0",
                "CriticalRate":"-0.5"
            },
            Gold: {
                "SpDefense": "5.0",
                "CriticalRate":"-0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue','black']
    },
    {
        en: "Geodude",
        zh: "小拳石",
        attr: {
            Bronze: {
                "Defense": "3.0",
                "SpDefense":"-3.0"
            },
            Silver: {
                "Defense": "4.0",
                "SpDefense":"-4.0"
            },
            Gold: {
                "Defense": "5.0",
                "SpDefense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Graveler",
        zh: "隆隆石",
        attr: {
            Bronze: {
                "Defense": "3.0",
                "CriticalRate":"-0.3"
            },
            Silver: {
                "Defense": "4.0",
                "CriticalRate":"-0.5"
            },
            Gold: {
                "Defense": "5.0",
                "CriticalRate":"-0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Golem",
        zh: "隆隆岩",
        attr: {
            Bronze: {
                "Defense": "3.0",
                "SpAttack":"-1.8"
            },
            Silver: {
                "Defense": "4.0",
                "SpAttack":"-2.4"
            },
            Gold: {
                "Defense": "5.0",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Ponyta",
        zh: "小火马",
        attr: {
            Bronze: {
                "HP": "-30",
                "Attack":"1.2"
            },
            Silver: {
                "HP": "-40",
                "Attack":"1.6"
            },
            Gold: {
                "HP": "-50",
                "Attack":"2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['red']
    },
    {
        en: "Rapidash",
        zh: "烈焰马",
        attr: {
            Bronze: {
                "Attack": "1.2",
                "Defense":"-3.0"
            },
            Silver: {
                "Attack": "1.6",
                "Defense":"-4.0"
            },
            Gold: {
                "Attack": "2.0",
                "Defense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['red']
    },
    {
        en: "Slowpoke",
        zh: "呆呆兽",
        attr: {
            Bronze: {
                "Defense": "3.0",
                "Speed":"-21.0"
            },
            Silver: {
                "Defense": "4.0",
                "Speed":"-28.0"
            },
            Gold: {
                "Defense": "5.0",
                "Speed":"-35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Slowbro",
        zh: "呆壳兽",
        attr: {
            Bronze: {
                "Defense": "3.0",
                "Speed":"-21.0"
            },
            Silver: {
                "Defense": "4.0",
                "Speed":"-28.0"
            },
            Gold: {
                "Defense": "5.0",
                "Speed":"-35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple','blue']
    },
    {
        en: "Magnemite",
        zh: "小磁怪",
        attr: {
            Bronze: {
                "HP": "-30",
                "Defense":"3.0"
            },
            Silver: {
                "HP": "-40",
                "Defense":"4.0"
            },
            Gold: {
                "HP": "-50",
                "Defense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['yellow']
    },
    {
        en: "Magneton",
        zh: "三合一小磁怪",
        attr: {
            Bronze: {
                "Attack": "-1.2",
                "Defense":"3.0"
            },
            Silver: {
                "Attack": "-1.6",
                "Defense":"4.0"
            },
            Gold: {
                "Attack": "-2.0",
                "Defense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['yellow']
    },
    {
        en: "Farfetch'd",
        zh: "大葱鸭",
        attr: {
            Bronze: {
                "HP": "-30",
                "CriticalRate":"0.3"
            },
            Silver: {
                "HP": "-40",
                "CriticalRate":"0.5"
            },
            Gold: {
                "HP": "-50",
                "CriticalRate":"0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Doduo",
        zh: "嘟嘟",
        attr: {
            Bronze: {
                "HP": "-30",
                "Speed":"21.0"
            },
            Silver: {
                "HP": "-40",
                "Speed":"28.0"
            },
            Gold: {
                "HP": "-50",
                "Speed":"35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Dodrio",
        zh: "嘟嘟利",
        attr: {
            Bronze: {
                "HP": "-30",
                "Speed":"21.0"
            },
            Silver: {
                "HP": "-40",
                "Speed":"28.0"
            },
            Gold: {
                "HP": "-50",
                "Speed":"35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Seel",
        zh: "小海狮",
        attr: {
            Bronze: {
                "HP": "30",
                "Attack":"-1.2"
            },
            Silver: {
                "HP": "40",
                "Attack":"-1.6"
            },
            Gold: {
                "HP": "50",
                "Attack":"-2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Dewgong",
        zh: "白海狮",
        attr: {
            Bronze: {
                "HP": "30",
                "SpAttack":"-1.8"
            },
            Silver: {
                "HP": "40",
                "SpAttack":"-2.4"
            },
            Gold: {
                "HP": "50",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Grimer",
        zh: "臭泥",
        attr: {
            Bronze: {
                "HP": "30",
                "Attack":"-1.2"
            },
            Silver: {
                "HP": "40",
                "Attack":"-1.6"
            },
            Gold: {
                "HP": "50",
                "Attack":"-2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['black']
    },
    {
        en: "Muk",
        zh: "臭臭泥",
        attr: {
            Bronze: {
                "HP": "30",
                "SpAttack":"-1.8"
            },
            Silver: {
                "HP": "40",
                "SpAttack":"-2.4"
            },
            Gold: {
                "HP": "50",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['black']
    },
    {
        en: "Shellder",
        zh: "大舌贝",
        attr: {
            Bronze: {
                "HP": "-30",
                "Defense":"3.0"
            },
            Silver: {
                "HP": "-40",
                "Defense":"4.0"
            },
            Gold: {
                "HP": "-50",
                "Defense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Cloyster",
        zh: "刺甲贝",
        attr: {
            Bronze: {
                "Defense": "3.0",
                "SpDefense":"-3.0"
            },
            Silver: {
                "Defense": "4.0",
                "SpDefense":"-4.0"
            },
            Gold: {
                "Defense": "5.0",
                "SpDefense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Gastly",
        zh: "鬼斯",
        attr: {
            Bronze: {
                "HP": "-30",
                "Speed":"21.0"
            },
            Silver: {
                "HP": "-40",
                "Speed":"28.0"
            },
            Gold: {
                "HP": "-50",
                "Speed":"35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple']
    },
    {
        en: "Haunter",
        zh: "鬼斯通",
        attr: {
            Bronze: {
                "Defense": "-3.0",
                "Speed":"21.0"
            },
            Silver: {
                "Defense": "-4.0",
                "Speed":"28.0"
            },
            Gold: {
                "Defense": "-5.0",
                "Speed":"35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple']
    },
    {
        en: "Gengar",
        zh: "耿鬼",
        attr: {
            Bronze: {
                "Attack": "-1.2",
                "Speed":"21.0"
            },
            Silver: {
                "Attack": "-1.6",
                "Speed":"28.0"
            },
            Gold: {
                "Attack": "-2.0",
                "Speed":"35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple','black']
    },
    {
        en: "Onix",
        zh: "大岩蛇",
        attr: {
            Bronze: {
                "HP": "-30",
                "Defense":"3.0"
            },
            Silver: {
                "HP": "-40",
                "Defense":"4.0"
            },
            Gold: {
                "HP": "-50",
                "Defense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Drowzee",
        zh: "催眠貘",
        attr: {
            Bronze: {
                "SpDefense": "3.0",
                "Speed":"-21.0"
            },
            Silver: {
                "SpDefense": "4.0",
                "Speed":"-28.0"
            },
            Gold: {
                "SpDefense": "5.0",
                "Speed":"-35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple']
    },
    {
        en: "Hypno",
        zh: "引梦貘人",
        attr: {
            Bronze: {
                "SpDefense": "3.0",
                "CriticalRate":"-0.3"
            },
            Silver: {
                "SpDefense": "4.0",
                "CriticalRate":"-0.5"
            },
            Gold: {
                "SpDefense": "5.0",
                "CriticalRate":"-0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple']
    },
    {
        en: "Krabby",
        zh: "大钳蟹",
        attr: {
            Bronze: {
                "HP": "-30",
                "Attack":"1.2"
            },
            Silver: {
                "HP": "-40",
                "Attack":"1.6"
            },
            Gold: {
                "HP": "-50",
                "Attack":"2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Kingler",
        zh: "巨钳蟹",
        attr: {
            Bronze: {
                "Attack": "1.2",
                "SpDefense":"-3.0"
            },
            Silver: {
                "Attack": "1.6",
                "SpDefense":"-4.0"
            },
            Gold: {
                "Attack": "2.0",
                "SpDefense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Voltorb",
        zh: "霹雳电球",
        attr: {
            Bronze: {
                "HP": "-30",
                "Speed":"21.0"
            },
            Silver: {
                "HP": "-40",
                "Speed":"28.0"
            },
            Gold: {
                "HP": "-50",
                "Speed":"35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['yellow']
    },
    {
        en: "Electrode",
        zh: "顽皮雷弹",
        attr: {
            Bronze: {
                "Attack": "-1.2",
                "Speed":"21.0"
            },
            Silver: {
                "Attack": "-1.6",
                "Speed":"28.0"
            },
            Gold: {
                "Attack": "-2.0",
                "Speed":"35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['yellow']
    },
    {
        en: "Exeggcute",
        zh: "蛋蛋",
        attr: {
            Bronze: {
                "SpAttack": "1.8",
                "SpDefense":"-3.0"
            },
            Silver: {
                "SpAttack": "2.4",
                "SpDefense":"-4.0"
            },
            Gold: {
                "SpAttack": "3.0",
                "SpDefense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Exeggutor",
        zh: "椰蛋树",
        attr: {
            Bronze: {
                "SpAttack": "1.8",
                "Speed":"-21.0"
            },
            Silver: {
                "SpAttack": "2.4",
                "Speed":"-28.0"
            },
            Gold: {
                "SpAttack": "3.0",
                "Speed":"-35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple','green']
    },
    {
        en: "Cubone",
        zh: "卡拉卡拉",
        attr: {
            Bronze: {
                "HP": "-30",
                "Attack":"1.2"
            },
            Silver: {
                "HP": "-40",
                "Attack":"1.6"
            },
            Gold: {
                "HP": "-50",
                "Attack":"2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Marowak",
        zh: "嘎啦嘎啦",
        attr: {
            Bronze: {
                "Attack": "1.2",
                "SpAttack":"-1.8"
            },
            Silver: {
                "Attack": "1.6",
                "SpAttack":"-2.4"
            },
            Gold: {
                "Attack": "2.0",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Hitmonlee",
        zh: "飞腿郎",
        attr: {
            Bronze: {
                "SpAttack": "-1.8",
                "SpDefense":"3.0"
            },
            Silver: {
                "SpAttack": "-2.4",
                "SpDefense":"4.0"
            },
            Gold: {
                "SpAttack": "-3.0",
                "SpDefense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Hitmonchan",
        zh: "快拳郎",
        attr: {
            Bronze: {
                "SpAttack": "-1.8",
                "SpDefense":"3.0"
            },
            Silver: {
                "SpAttack": "-2.4",
                "SpDefense":"4.0"
            },
            Gold: {
                "SpAttack": "-3.0",
                "SpDefense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Lickitung",
        zh: "大舌头",
        attr: {
            Bronze: {
                "SpAttack": "1.8",
                "CriticalRate":"-0.3"
            },
            Silver: {
                "SpAttack": "2.4",
                "CriticalRate":"-0.5"
            },
            Gold: {
                "SpAttack": "3.0",
                "CriticalRate":"-0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Koffing",
        zh: "瓦斯弹",
        attr: {
            Bronze: {
                "HP": "-30",
                "Defense":"3.0"
            },
            Silver: {
                "HP": "-40",
                "Defense":"4.0"
            },
            Gold: {
                "HP": "-50",
                "Defense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple']
    },
    {
        en: "Weezing",
        zh: "双弹瓦斯",
        attr: {
            Bronze: {
                "Defense": "3.0",
                "Speed":"-21.0"
            },
            Silver: {
                "Defense": "4.0",
                "Speed":"-28.0"
            },
            Gold: {
                "Defense": "5.0",
                "Speed":"-35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple']
    },
    {
        en: "Rhyhorn",
        zh: "独角犀牛",
        attr: {
            Bronze: {
                "HP": "30",
                "Speed":"-21.0"
            },
            Silver: {
                "HP": "40",
                "Speed":"-28.0"
            },
            Gold: {
                "HP": "50",
                "Speed":"-35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Rhydon",
        zh: "钻角犀兽",
        attr: {
            Bronze: {
                "HP": "30",
                "SpDefense":"-3.0"
            },
            Silver: {
                "HP": "40",
                "SpDefense":"-4.0"
            },
            Gold: {
                "HP": "50",
                "SpDefense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Chansey",
        zh: "吉利蛋",
        attr: {
            Bronze: {
                "HP": "30",
                "Defense":"-3.0"
            },
            Silver: {
                "HP": "40",
                "Defense":"-4.0"
            },
            Gold: {
                "HP": "50",
                "Defense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Tangela",
        zh: "藤蔓怪",
        attr: {
            Bronze: {
                "Defense": "3.0",
                "SpDefense":"-3.0"
            },
            Silver: {
                "Defense": "4.0",
                "SpDefense":"-4.0"
            },
            Gold: {
                "Defense": "5.0",
                "SpDefense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Kangaskhan",
        zh: "袋兽",
        attr: {
            Bronze: {
                "HP": "30",
                "SpAttack":"-1.8"
            },
            Silver: {
                "HP": "40",
                "SpAttack":"-2.4"
            },
            Gold: {
                "HP": "50",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Horsea",
        zh: "墨海马",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpAttack":"1.8"
            },
            Silver: {
                "HP": "-40",
                "SpAttack":"2.4"
            },
            Gold: {
                "HP": "-50",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Seadra",
        zh: "海刺龙",
        attr: {
            Bronze: {
                "SpAttack": "1.8",
                "SpDefense":"-3.0"
            },
            Silver: {
                "SpAttack": "2.4",
                "SpDefense":"-4.0"
            },
            Gold: {
                "SpAttack": "3.0",
                "SpDefense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Goldeen",
        zh: "角金鱼",
        attr: {
            Bronze: {
                "HP": "30",
                "SpDefense":"-3.0"
            },
            Silver: {
                "HP": "40",
                "SpDefense":"-4.0"
            },
            Gold: {
                "HP": "50",
                "SpDefense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Seaking",
        zh: "金鱼王",
        attr: {
            Bronze: {
                "SpAttack": "-1.8",
                "HP":"30"
            },
            Silver: {
                "SpAttack": "-2.4",
                "HP":"40"
            },
            Gold: {
                "SpAttack": "-3.0",
                "HP":"50"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Staryu",
        zh: "海星星",
        attr: {
            Bronze: {
                "HP": "-30",
                "Speed":"21.0"
            },
            Silver: {
                "HP": "-40",
                "Speed":"28.0"
            },
            Gold: {
                "HP": "-50",
                "Speed":"35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Starmie",
        zh: "宝石海星",
        attr: {
            Bronze: {
                "Attack": "-1.2",
                "Speed":"21.0"
            },
            Silver: {
                "Attack": "-1.6",
                "Speed":"28.0"
            },
            Gold: {
                "Attack": "-2.0",
                "Speed":"35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue','purple']
    },
    {
        en: "Mr_Mime",
        zh: "魔墙人偶",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpDefense":"3.0"
            },
            Silver: {
                "HP": "-40",
                "SpDefense":"4.0"
            },
            Gold: {
                "HP": "-50",
                "SpDefense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple','pink']
    },
    {
        en: "Scyther",
        zh: "飞天螳螂",
        attr: {
            Bronze: {
                "Defense": "-3.0",
                "CriticalRate":"0.3"
            },
            Silver: {
                "Defense": "-4.0",
                "CriticalRate":"0.5"
            },
            Gold: {
                "Defense": "-5.0",
                "CriticalRate":"0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green','white']
    },
    {
        en: "Jynx",
        zh: "迷唇姐",
        attr: {
            Bronze: {
                "SpAttack": "1.8",
                "Defense":"-3.0"
            },
            Silver: {
                "SpAttack": "2.4",
                "Defense":"-4.0"
            },
            Gold: {
                "SpAttack": "3.0",
                "Defense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple','blue']
    },
    {
        en: "Electabuzz",
        zh: "电击兽",
        attr: {
            Bronze: {
                "Attack": "1.2",
                "Defense":"-3.0"
            },
            Silver: {
                "Attack": "1.6",
                "Defense":"-4.0"
            },
            Gold: {
                "Attack": "2.0",
                "Defense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['yellow']
    },
    {
        en: "Magmar",
        zh: "鸭嘴火兽",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpAttack":"1.8"
            },
            Silver: {
                "HP": "-40",
                "SpAttack":"2.4"
            },
            Gold: {
                "HP": "-50",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['red']
    },
    {
        en: "Pinsir",
        zh: "凯罗斯",
        attr: {
            Bronze: {
                "SpDefense": "-3.0",
                "CriticalRate":"0.3"
            },
            Silver: {
                "SpDefense": "-4.0",
                "CriticalRate":"0.5"
            },
            Gold: {
                "SpDefense": "-5.0",
                "CriticalRate":"0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Tauros",
        zh: "肯泰罗",
        attr: {
            Bronze: {
                "Attack": "1.2",
                "SpAttack":"-1.8"
            },
            Silver: {
                "Attack": "1.6",
                "SpAttack":"-2.4"
            },
            Gold: {
                "Attack": "2.0",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Magikarp",
        zh: "鲤鱼王",
        attr: {
            Bronze: {
                "HP": "-30",
                "Attack":"1.2"
            },
            Silver: {
                "HP": "-40",
                "Attack":"1.6"
            },
            Gold: {
                "HP": "-50",
                "Attack":"2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Gyarados",
        zh: "暴鲤龙",
        attr: {
            Bronze: {
                "Attack": "1.2",
                "SpAttack":"-1.8"
            },
            Silver: {
                "Attack": "1.6",
                "SpAttack":"-2.4"
            },
            Gold: {
                "Attack": "2.0",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue','white']
    },
    {
        en: "Lapras",
        zh: "拉普拉斯",
        attr: {
            Bronze: {
                "HP": "30",
                "Speed":"-21.0"
            },
            Silver: {
                "HP": "40",
                "Speed":"-28.0"
            },
            Gold: {
                "HP": "50",
                "Speed":"-35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Ditto",
        zh: "百变怪",
        attr: {
            Bronze: {
                
            },
            Silver: {
               
            },
            Gold: {
                
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Eevee",
        zh: "伊布",
        attr: {
            Bronze: {
                "SpAttack": "-1.8",
                "SpDefense":"3.0"
            },
            Silver: {
                "SpAttack": "-2.4",
                "SpDefense":"4.0"
            },
            Gold: {
                "SpAttack": "-3.0",
                "SpDefense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Vaporeon",
        zh: "水伊布",
        attr: {
            Bronze: {
                "HP": "30",
                "Attack":"-1.2"
            },
            Silver: {
                "HP": "40",
                "Attack":"-1.6"
            },
            Gold: {
                "HP": "50",
                "Attack":"-2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Jolteon",
        zh: "雷伊布",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpAttack":"1.8"
            },
            Silver: {
                "HP": "-40",
                "SpAttack":"2.4"
            },
            Gold: {
                "HP": "-50",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['yellow']
    },
    {
        en: "Flareon",
        zh: "火伊布",
        attr: {
            Bronze: {
                "Defense": "-3.0",
                "Attack":"1.2"
            },
            Silver: {
                "Defense": "-4.0",
                "Attack":"1.6"
            },
            Gold: {
                "Defense": "-5.0",
                "Attack":"2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['red']
    },
    {
        en: "Porygon",
        zh: "多边兽",
        attr: {
            Bronze: {
                "Attack": "-1.2",
                "SpAttack":"1.8"
            },
            Silver: {
                "Attack": "-1.6",
                "SpAttack":"2.4"
            },
            Gold: {
                "Attack": "-2.0",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Omanyte",
        zh: "菊石兽",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpAttack":"1.8"
            },
            Silver: {
                "HP": "-40",
                "SpAttack":"2.4"
            },
            Gold: {
                "HP": "-50",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Omastar",
        zh: "多刺菊石兽",
        attr: {
            Bronze: {
                "Speed": "-21.0",
                "SpAttack":"1.8"
            },
            Silver: {
                "Speed": "-28.0",
                "SpAttack":"2.4"
            },
            Gold: {
                "Speed": "-35.0",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown','blue']
    },
    {
        en: "Kabuto",
        zh: "化石盔",
        attr: {
            Bronze: {
                "HP": "-30",
                "CriticalRate":"0.3"
            },
            Silver: {
                "HP": "-40",
                "CriticalRate":"0.5"
            },
            Gold: {
                "HP": "-50",
                "CriticalRate":"0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Kabutops",
        zh: "镰刀盔",
        attr: {
            Bronze: {
                "CriticalRate": "0.3",
                "SpAttack":"-1.8"
            },
            Silver: {
                "CriticalRate": "0.5",
                "SpAttack":"-2.4"
            },
            Gold: {
                "CriticalRate": "0.6",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown','blue']
    },
    {
        en: "Aerodactyl",
        zh: "化石翼龙",
        attr: {
            Bronze: {
                "Defense": "-3.0",
                "Speed":"21.0"
            },
            Silver: {
                "Defense": "-4.0",
                "Speed":"28.0"
            },
            Gold: {
                "Defense": "-5.0",
                "Speed":"35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown','white']
    },
    {
        en: "Snorlax",
        zh: "卡比兽",
        attr: {
            Bronze: {
                "SpDefense": "3.0",
                "CriticalRate":"-0.3"
            },
            Silver: {
                "SpDefense": "4.0",
                "CriticalRate":"-0.5"
            },
            Gold: {
                "SpDefense": "5.0",
                "CriticalRate":"-0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Articuno",
        zh: "急冻鸟",
        attr: {
            Bronze: {
                "Attack": "-1.2",
                "SpAttack":"1.8"
            },
            Silver: {
                "Attack": "-1.6",
                "SpAttack":"2.4"
            },
            Gold: {
                "Attack": "-2.0",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white','blue']
    },
    {
        en: "Zapdos",
        zh: "闪电鸟",
        attr: {
            Bronze: {
                "HP": "30",
                "Attack":"-1.2"
            },
            Silver: {
                "HP": "40",
                "Attack":"-1.6"
            },
            Gold: {
                "HP": "50",
                "Attack":"-2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['yellow','white']
    },
    {
        en: "Moltres",
        zh: "火焰鸟",
        attr: {
            Bronze: {
                "SpDefense": "-3.0",
                "SpAttack":"1.8"
            },
            Silver: {
                "SpDefense": "-4.0",
                "SpAttack":"2.4"
            },
            Gold: {
                "SpDefense": "-5.0",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white','red']
    },
    {
        en: "Dratini",
        zh: "迷你龙",
        attr: {
            Bronze: {
                "HP": "30",
                "Speed":"-21.0"
            },
            Silver: {
                "HP": "40",
                "Speed":"-28.0"
            },
            Gold: {
                "HP": "50",
                "Speed":"-35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['navy']
    },
    {
        en: "Dragonair",
        zh: "哈克龙",
        attr: {
            Bronze: {
                "HP": "30",
                "Attack":"-1.2"
            },
            Silver: {
                "HP": "40",
                "Attack":"-1.6"
            },
            Gold: {
                "HP": "50",
                "Attack":"-2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['navy']
    },
    {
        en: "Dragonite",
        zh: "快龙",
        attr: {
            Bronze: {
                "HP": "30",
                "SpDefense":"-3.0"
            },
            Silver: {
                "HP": "40",
                "SpDefense":"-4.0"
            },
            Gold: {
                "HP": "50",
                "SpDefense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white','navy']
    },
    {
        en: "Mewtwo",
        zh: "超梦",
        attr: {
            Bronze: {
                "HP": "-30",
                "ColddownReduction":"0.3"
            },
            Silver: {
                "HP": "-40",
                "ColddownReduction":"0.5"
            },
            Gold: {
                "HP": "-50",
                "ColddownReduction":"0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple']
    },
    {
        en: "Mew",
        zh: "梦幻",
        attr: {
            Bronze: {
                "HP": "-30",
                "ColddownReduction":"0.3"
            },
            Silver: {
                "HP": "-40",
                "ColddownReduction":"0.5"
            },
            Gold: {
                "HP": "-50",
                "ColddownReduction":"0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple']
    },
    {
        en: "Chikorita",
        zh: "菊草叶",
        attr: {
            Bronze: {
                "HP": "-30",
                "Defense":"3.0"
            },
            Silver: {
                "HP": "-40",
                "Defense":"4.0"
            },
            Gold: {
                "HP": "-50",
                "Defense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Bayleef",
        zh: "月桂叶",
        attr: {
            Bronze: {
                "Defense": "3.0",
                "Speed":"-21.0"
            },
            Silver: {
                "Defense": "4.0",
                "Speed":"-28.0"
            },
            Gold: {
                "Defense": "5.0",
                "Speed":"-35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Meganium",
        zh: "大竺葵",
        attr: {
            Bronze: {
                "Defense": "3.0",
                "Attack":"-1.2"
            },
            Silver: {
                "Defense": "4.0",
                "Attack":"-1.6"
            },
            Gold: {
                "Defense": "5.0",
                "Attack":"-2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Cyndaquil",
        zh: "火球鼠",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpAttack":"1.8"
            },
            Silver: {
                "HP": "-40",
                "SpAttack":"2.4"
            },
            Gold: {
                "HP": "-50",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['red']
    },
    {
        en: "Quilava",
        zh: "火岩鼠",
        attr: {
            Bronze: {
                "Defense": "-3.0",
                "SpAttack":"1.8"
            },
            Silver: {
                "Defense": "-4.0",
                "SpAttack":"2.4"
            },
            Gold: {
                "Defense": "-5.0",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['red']
    },
    {
        en: "Typhlosion",
        zh: "火暴兽",
        attr: {
            Bronze: {
                "SpDefense": "-3.0",
                "SpAttack":"1.8"
            },
            Silver: {
                "SpDefense": "-4.0",
                "SpAttack":"2.4"
            },
            Gold: {
                "SpDefense": "-5.0",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['red']
    },
    {
        en: "Totodile",
        zh: "小锯鳄",
        attr: {
            Bronze: {
                "HP": "-30",
                "Defense":"3.0"
            },
            Silver: {
                "HP": "-40",
                "Defense":"4.0"
            },
            Gold: {
                "HP": "-50",
                "Defense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Croconaw",
        zh: "蓝鳄",
        attr: {
            Bronze: {
                "SpDefense": "-3.0",
                "Defense":"3.0"
            },
            Silver: {
                "SpDefense": "-4.0",
                "Defense":"4.0"
            },
            Gold: {
                "SpDefense": "-5.0",
                "Defense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Feraligatr",
        zh: "大力鳄",
        attr: {
            Bronze: {
                "Defense": "3.0",
                "SpAttack":"-1.8"
            },
            Silver: {
                "Defense": "4.0",
                "SpAttack":"-2.4"
            },
            Gold: {
                "Defense": "5.0",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Sentret",
        zh: "尾立",
        attr: {
            Bronze: {
                "SpDefense": "-3.0",
                "CriticalRate":"0.3"
            },
            Silver: {
                "SpDefense": "-4.0",
                "CriticalRate":"0.5"
            },
            Gold: {
                "SpDefense": "-5.0",
                "CriticalRate":"0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Furret",
        zh: "大尾立",
        attr: {
            Bronze: {
                "CriticalRate": "0.3",
                "SpAttack":"-1.8"
            },
            Silver: {
                "CriticalRate": "0.5",
                "SpAttack":"-2.4"
            },
            Gold: {
                "CriticalRate": "0.6",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Hoothoot",
        zh: "咕咕",
        attr: {
            Bronze: {
                "Attack": "-1.2",
                "CriticalRate":"0.3"
            },
            Silver: {
                "Attack": "-1.6",
                "CriticalRate":"0.5"
            },
            Gold: {
                "Attack": "-2.0",
                "CriticalRate":"0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Noctowl",
        zh: "猫头夜鹰",
        attr: {
            Bronze: {
                "Defense": "-3.0",
                "CriticalRate":"0.3"
            },
            Silver: {
                "Defense": "-4.0",
                "CriticalRate":"0.5"
            },
            Gold: {
                "Defense": "-5.0",
                "CriticalRate":"0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Ledyba",
        zh: "芭瓢虫",
        attr: {
            Bronze: {
                "SpDefense": "3.0",
                "CriticalRate":"-0.3"
            },
            Silver: {
                "SpDefense": "4.0",
                "CriticalRate":"-0.5"
            },
            Gold: {
                "SpDefense": "5.0",
                "CriticalRate":"-0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Ledian",
        zh: "安瓢虫",
        attr: {
            Bronze: {
                "SpDefense": "3.0",
                "Attack":"-1.2"
            },
            Silver: {
                "SpDefense": "4.0",
                "Attack":"-1.6"
            },
            Gold: {
                "SpDefense": "5.0",
                "Attack":"-2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Spinarak",
        zh: "圆丝蛛",
        attr: {
            Bronze: {
                "Attack": "1.2",
                "CriticalRate":"-0.3"
            },
            Silver: {
                "Attack": "1.6",
                "CriticalRate":"-0.5"
            },
            Gold: {
                "Attack": "2.0",
                "CriticalRate":"-0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Ariados",
        zh: "阿利多斯",
        attr: {
            Bronze: {
                "SpAttack": "-1.8",
                "Attack":"1.2"
            },
            Silver: {
                "SpAttack": "-2.4",
                "Attack":"1.6"
            },
            Gold: {
                "SpAttack": "-3.0",
                "Attack":"2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['black']
    },
    {
        en: "Crobat",
        zh: "叉字蝠",
        attr: {
            Bronze: {
                "Speed": "21.0",
                "SpAttack":"-1.8"
            },
            Silver: {
                "Speed": "28.0",
                "SpAttack":"-2.4"
            },
            Gold: {
                "Speed": "35.0",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['black']
    },
    {
        en: "Chinchou",
        zh: "灯笼鱼",
        attr: {
            Bronze: {
                "HP": "30",
                "Defense":"-3.0"
            },
            Silver: {
                "HP": "40",
                "Defense":"-4.0"
            },
            Gold: {
                "HP": "50",
                "Defense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['yellow']
    },
    {
        en: "Lanturn",
        zh: "电灯怪",
        attr: {
            Bronze: {
                "HP": "30",
                "Attack":"-1.2"
            },
            Silver: {
                "HP": "40",
                "Attack":"-1.6"
            },
            Gold: {
                "HP": "50",
                "Attack":"-2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['yellow']
    },
    {
        en: "Pichu",
        zh: "皮丘",
        attr: {
            Bronze: {
                "Attack": "-1.2",
                "Speed":"21.0"
            },
            Silver: {
                "Attack": "-1.6",
                "Speed":"28.0"
            },
            Gold: {
                "Attack": "-2.0",
                "Speed":"35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['yellow']
    },
    {
        en: "Cleffa",
        zh: "皮宝宝",
        attr: {
            Bronze: {
                "HP": "30",
                "Defense":"-3.0"
            },
            Silver: {
                "HP": "40",
                "Defense":"-4.0"
            },
            Gold: {
                "HP": "50",
                "Defense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['pink']
    },
    {
        en: "Igglybuff",
        zh: "宝宝丁",
        attr: {
            Bronze: {
                "HP": "30",
                "Defense":"-3.0"
            },
            Silver: {
                "HP": "40",
                "Defense":"-4.0"
            },
            Gold: {
                "HP": "50",
                "Defense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['pink']
    },
    {
        en: "Togepi",
        zh: "波克比",
        attr: {
            Bronze: {
                "Speed": "-21.0",
                "SpDefense":"3.0"
            },
            Silver: {
                "Speed": "-28.0",
                "SpDefense":"4.0"
            },
            Gold: {
                "Speed": "-35.0",
                "SpDefense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['pink']
    },
    {
        en: "Togetic",
        zh: "波克基古",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpDefense":"3.0"
            },
            Silver: {
                "HP": "-40",
                "SpDefense":"4.0"
            },
            Gold: {
                "HP": "-50",
                "SpDefense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white','pink']
    },
    {
        en: "Natu",
        zh: "天然雀",
        attr: {
            Bronze: {
                "CriticalRate": "-0.3",
                "Speed":"21.0"
            },
            Silver: {
                "CriticalRate": "-0.5",
                "Speed":"28.0"
            },
            Gold: {
                "CriticalRate": "-0.6",
                "Speed":"35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple']
    },
    {
        en: "Xatu",
        zh: "天然鸟",
        attr: {
            Bronze: {
                "Defense": "-3.0",
                "Speed":"21.0"
            },
            Silver: {
                "Defense": "-4.0",
                "Speed":"28.0"
            },
            Gold: {
                "Defense": "-5.0",
                "Speed":"35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple','white']
    },
    {
        en: "Mareep",
        zh: "咩利羊",
        attr: {
            Bronze: {
                "Defense": "-3.0",
                "SpAttack":"1.8"
            },
            Silver: {
                "Defense": "-4.0",
                "SpAttack":"2.4"
            },
            Gold: {
                "Defense": "-5.0",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['yellow']
    },
    {
        en: "Flaaffy",
        zh: "茸茸羊",
        attr: {
            Bronze: {
                "CriticalRate": "-0.3",
                "SpAttack":"1.8"
            },
            Silver: {
                "CriticalRate": "-0.5",
                "SpAttack":"2.4"
            },
            Gold: {
                "CriticalRate": "-0.6",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['yellow']
    },
    {
        en: "Ampharos",
        zh: "电龙",
        attr: {
            Bronze: {
                "Attack": "-1.2",
                "SpAttack":"1.8"
            },
            Silver: {
                "Attack": "-1.6",
                "SpAttack":"2.4"
            },
            Gold: {
                "Attack": "-2.0",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['yellow']
    },
    {
        en: "Bellossom",
        zh: "美丽花",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpAttack":"1.8"
            },
            Silver: {
                "HP": "-40",
                "SpAttack":"2.4"
            },
            Gold: {
                "HP": "-50",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Marill",
        zh: "玛丽露",
        attr: {
            Bronze: {
                "HP": "30",
                "Speed":"-21.0"
            },
            Silver: {
                "HP": "40",
                "Speed":"-28.0"
            },
            Gold: {
                "HP": "50",
                "Speed":"-35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['pink']
    },
    {
        en: "Azumarill",
        zh: "玛力露丽",
        attr: {
            Bronze: {
                "HP": "30",
                "Speed":"-21.0"
            },
            Silver: {
                "HP": "40",
                "Speed":"-28.0"
            },
            Gold: {
                "HP": "50",
                "Speed":"-35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['pink','blue']
    },
    {
        en: "Sudowoodo",
        zh: "树才怪",
        attr: {
            Bronze: {
                "CriticalRate": "-0.3",
                "Defense":"3.0"
            },
            Silver: {
                "CriticalRate": "-0.5",
                "Defense":"4.0"
            },
            Gold: {
                "CriticalRate": "-0.6",
                "Defense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Politoed",
        zh: "蚊香蛙皇",
        attr: {
            Bronze: {
                "Attack": "-1.2",
                "SpDefense":"3.0"
            },
            Silver: {
                "Attack": "-1.6",
                "SpDefense":"4.0"
            },
            Gold: {
                "Attack": "-2.0",
                "SpDefense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Hoppip",
        zh: "毽子草",
        attr: {
            Bronze: {
                "HP": "-30",
                "Speed":"21.0"
            },
            Silver: {
                "HP": "-40",
                "Speed":"28.0"
            },
            Gold: {
                "HP": "-50",
                "Speed":"35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Skiploom",
        zh: "毽子花",
        attr: {
            Bronze: {
                "SpAttack": "-1.8",
                "Speed":"21.0"
            },
            Silver: {
                "SpAttack": "-2.4",
                "Speed":"28.0"
            },
            Gold: {
                "SpAttack": "-3.0",
                "Speed":"35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Jumpluff",
        zh: "毽子棉",
        attr: {
            Bronze: {
                "Attack": "-1.2",
                "Speed":"21.0"
            },
            Silver: {
                "Attack": "-1.6",
                "Speed":"28.0"
            },
            Gold: {
                "Attack": "-2.0",
                "Speed":"35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white','green']
    },
    {
        en: "Aipom",
        zh: "长尾怪手",
        attr: {
            Bronze: {
                "CriticalRate": "0.3",
                "Defense":"-3.0"
            },
            Silver: {
                "CriticalRate": "0.5",
                "Defense":"-4.0"
            },
            Gold: {
                "CriticalRate": "0.6",
                "Defense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Sunkern",
        zh: "向日种子",
        attr: {
            Bronze: {
                "HP": "30",
                "Defense":"-3.0"
            },
            Silver: {
                "HP": "40",
                "Defense":"-4.0"
            },
            Gold: {
                "HP": "50",
                "Defense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Sunflora",
        zh: "向日花怪",
        attr: {
            Bronze: {
                "HP": "30",
                "SpDefense":"-3.0"
            },
            Silver: {
                "HP": "40",
                "SpDefense":"-4.0"
            },
            Gold: {
                "HP": "50",
                "SpDefense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Yanma",
        zh: "蜻蜻蜓",
        attr: {
            Bronze: {
                "Defense": "-3.0",
                "Speed":"21.0"
            },
            Silver: {
                "Defense": "-4.0",
                "Speed":"28.0"
            },
            Gold: {
                "Defense": "-5.0",
                "Speed":"35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Wooper",
        zh: "乌波",
        attr: {
            Bronze: {
                "HP": "30",
                "SpAttack":"-1.8"
            },
            Silver: {
                "HP": "40",
                "SpAttack":"-2.4"
            },
            Gold: {
                "HP": "50",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Quagsire",
        zh: "沼王",
        attr: {
            Bronze: {
                "HP": "30",
                "SpDefense":"-3.0"
            },
            Silver: {
                "HP": "40",
                "SpDefense":"-4.0"
            },
            Gold: {
                "HP": "50",
                "SpDefense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue','brown']
    },
    {
        en: "Espeon",
        zh: "太阳伊布",
        attr: {
            Bronze: {
                "Defense": "-3.0",
                "SpAttack":"1.8"
            },
            Silver: {
                "Defense": "-4.0",
                "SpAttack":"2.4"
            },
            Gold: {
                "Defense": "-5.0",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple']
    },
    {
        en: "Umbreon",
        zh: "月亮伊布",
        attr: {
            Bronze: {
                "SpDefense": "3.0",
                "SpAttack":"-1.8"
            },
            Silver: {
                "SpDefense": "4.0",
                "SpAttack":"-2.4"
            },
            Gold: {
                "SpDefense": "5.0",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['black']
    },
    {
        en: "Murkrow",
        zh: "黑暗鸦",
        attr: {
            Bronze: {
                "SpDefense": "-3.0",
                "SpAttack":"1.8"
            },
            Silver: {
                "SpDefense": "-4.0",
                "SpAttack":"2.4"
            },
            Gold: {
                "SpDefense": "-5.0",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['black']
    },
    {
        en: "Slowking",
        zh: "呆呆王",
        attr: {
            Bronze: {
                "SpDefense": "3.0",
                "Speed":"-21.0"
            },
            Silver: {
                "SpDefense": "4.0",
                "Speed":"-28.0"
            },
            Gold: {
                "SpDefense": "5.0",
                "Speed":"-35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple','blue']
    },
    {
        en: "Misdreavus",
        zh: "梦妖",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpDefense":"3.0"
            },
            Silver: {
                "HP": "-40",
                "SpDefense":"4.0"
            },
            Gold: {
                "HP": "-50",
                "SpDefense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple']
    },
    {
        en: "Unown",
        zh: "未知图腾",
        attr: {
            Bronze: {
                "HP": "-30",
                "Attack":"1.2"
            },
            Silver: {
                "HP": "-40",
                "Attack":"1.6"
            },
            Gold: {
                "HP": "-50",
                "Attack":"2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple']
    },
    {
        en: "Wobbuffet",
        zh: "果然翁",
        attr: {
            Bronze: {
                "CriticalRate": "-0.3",
                "HP":"30"
            },
            Silver: {
                "CriticalRate": "-0.5",
                "HP":"40"
            },
            Gold: {
                "CriticalRate": "-0.6",
                "HP":"50"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple']
    },
    {
        en: "Girafarig",
        zh: "麒麟奇",
        attr: {
            Bronze: {
                "SpDefense": "-3.0",
                "HP":"30"
            },
            Silver: {
                "SpDefense": "-4.0",
                "HP":"40"
            },
            Gold: {
                "SpDefense": "-5.0",
                "HP":"50"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple']
    },
    {
        en: "Pineco",
        zh: "榛果球",
        attr: {
            Bronze: {
                "Defense": "3.0",
                "HP":"-30"
            },
            Silver: {
                "Defense": "4.0",
                "HP":"-40"
            },
            Gold: {
                "Defense": "5.0",
                "HP":"-50"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green']
    },
    {
        en: "Forretress",
        zh: "佛烈托斯",
        attr: {
            Bronze: {
                "Defense": "3.0",
                "SpAttack":"-1.8"
            },
            Silver: {
                "Defense": "4.0",
                "SpAttack":"-2.4"
            },
            Gold: {
                "Defense": "5.0",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['gray']
    },
    {
        en: "Dunsparce",
        zh: "土龙弟弟",
        attr: {
            Bronze: {
                "HP": "30",
                "SpAttack":"-1.8"
            },
            Silver: {
                "HP": "40",
                "SpAttack":"-2.4"
            },
            Gold: {
                "HP": "50",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Gligar",
        zh: "天蝎",
        attr: {
            Bronze: {
                "Defense": "3.0",
                "SpAttack":"-1.8"
            },
            Silver: {
                "Defense": "4.0",
                "SpAttack":"-2.4"
            },
            Gold: {
                "Defense": "5.0",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Steelix",
        zh: "大钢蛇",
        attr: {
            Bronze: {
                "Defense": "3.0",
                "SpDefense":"-3.0"
            },
            Silver: {
                "Defense": "4.0",
                "SpDefense":"-4.0"
            },
            Gold: {
                "Defense": "5.0",
                "SpDefense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown','gray']
    },
    {
        en: "Snubbull",
        zh: "布鲁",
        attr: {
            Bronze: {
                "HP": "-30",
                "Attack":"1.2"
            },
            Silver: {
                "HP": "-40",
                "Attack":"1.6"
            },
            Gold: {
                "HP": "-50",
                "Attack":"2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['pink']
    },
    {
        en: "Granbull",
        zh: "布鲁皇",
        attr: {
            Bronze: {
                "SpDefense": "-3.0",
                "Attack":"1.2"
            },
            Silver: {
                "SpDefense": "-4.0",
                "Attack":"1.6"
            },
            Gold: {
                "SpDefense": "-5.0",
                "Attack":"2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['pink']
    },
    {
        en: "Qwilfish",
        zh: "千针鱼",
        attr: {
            Bronze: {
                "SpDefense": "-3.0",
                "HP":"30"
            },
            Silver: {
                "SpDefense": "-4.0",
                "HP":"40"
            },
            Gold: {
                "SpDefense": "-5.0",
                "HP":"50"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['black']
    },
    {
        en: "Scizor",
        zh: "巨钳螳螂",
        attr: {
            Bronze: {
                "CriticalRate": "0.3",
                "SpDefense":"-3.0"
            },
            Silver: {
                "CriticalRate": "0.5",
                "SpDefense":"-4.0"
            },
            Gold: {
                "CriticalRate": "0.6",
                "SpDefense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['gray']
    },
    {
        en: "Shuckle",
        zh: "壶壶",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpDefense":"3.0"
            },
            Silver: {
                "HP": "-40",
                "SpDefense":"4.0"
            },
            Gold: {
                "HP": "-50",
                "SpDefense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Heracross",
        zh: "赫拉克罗斯",
        attr: {
            Bronze: {
                "HP": "-30",
                "Attack":"1.2"
            },
            Silver: {
                "HP": "-40",
                "Attack":"1.6"
            },
            Gold: {
                "HP": "-50",
                "Attack":"2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Sneasel",
        zh: "纽拉",
        attr: {
            Bronze: {
                "CriticalRate": "0.3",
                "HP":"-30"
            },
            Silver: {
                "CriticalRate": "0.5",
                "HP":"-40"
            },
            Gold: {
                "CriticalRate": "0.6",
                "HP":"-50"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['black']
    },
    {
        en: "Teddiursa",
        zh: "熊宝宝",
        attr: {
            Bronze: {
                "Attack": "1.2",
                "HP":"-30"
            },
            Silver: {
                "Attack": "1.6",
                "HP":"-40"
            },
            Gold: {
                "Attack": "2.0",
                "HP":"-50"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Ursaring",
        zh: "圈圈熊",
        attr: {
            Bronze: {
                "Attack": "1.2",
                "Speed":"-21.0"
            },
            Silver: {
                "Attack": "1.6",
                "Speed":"-28.0"
            },
            Gold: {
                "Attack": "2.0",
                "Speed":"-35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Slugma",
        zh: "熔岩虫",
        attr: {
            Bronze: {
                "Attack": "-1.2",
                "Defense":"3.0"
            },
            Silver: {
                "Attack": "-1.6",
                "Defense":"4.0"
            },
            Gold: {
                "Attack": "-2.0",
                "Defense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['red']
    },
    {
        en: "Magcargo",
        zh: "熔岩蜗牛",
        attr: {
            Bronze: {
                "Defense": "3.0",
                "HP":"-30"
            },
            Silver: {
                "Defense": "4.0",
                "HP":"-40"
            },
            Gold: {
                "Defense": "5.0",
                "HP":"-50"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['red']
    },
    {
        en: "Swinub",
        zh: "小山猪",
        attr: {
            Bronze: {
                "SpDefense": "-3.0",
                "HP":"30"
            },
            Silver: {
                "SpDefense": "-4.0",
                "HP":"40"
            },
            Gold: {
                "SpDefense": "-5.0",
                "HP":"50"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Piloswine",
        zh: "长毛猪",
        attr: {
            Bronze: {
                "CriticalRate": "-0.3",
                "HP":"30"
            },
            Silver: {
                "CriticalRate": "-0.5",
                "HP":"40"
            },
            Gold: {
                "CriticalRate": "-0.6",
                "HP":"50"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown','blue']
    },
    {
        en: "Corsola",
        zh: "太阳珊瑚",
        attr: {
            Bronze: {
                "Attack": "-1.2",
                "SpDefense":"3.0"
            },
            Silver: {
                "Attack": "-1.6",
                "SpDefense":"4.0"
            },
            Gold: {
                "Attack": "-2.0",
                "SpDefense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Remoraid",
        zh: "铁炮鱼",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpAttack":"1.8"
            },
            Silver: {
                "HP": "-40",
                "SpAttack":"2.4"
            },
            Gold: {
                "HP": "-50",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Octillery",
        zh: "章鱼桶",
        attr: {
            Bronze: {
                "Defense": "-3.0",
                "SpAttack":"1.8"
            },
            Silver: {
                "Defense": "-4.0",
                "SpAttack":"2.4"
            },
            Gold: {
                "Defense": "-5.0",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Delibird",
        zh: "信使鸟",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpAttack":"1.8"
            },
            Silver: {
                "HP": "-40",
                "SpAttack":"2.4"
            },
            Gold: {
                "HP": "-50",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue','white']
    },
    {
        en: "Mantine",
        zh: "巨翅飞鱼",
        attr: {
            Bronze: {
                "Attack": "-1.2",
                "SpDefense":"3.0"
            },
            Silver: {
                "Attack": "-1.6",
                "SpDefense":"4.0"
            },
            Gold: {
                "Attack": "-2.0",
                "SpDefense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue','white']
    },
    {
        en: "Skarmory",
        zh: "盔甲鸟",
        attr: {
            Bronze: {
                "Attack": "1.2",
                "HP":"-30"
            },
            Silver: {
                "Attack": "1.6",
                "HP":"-40"
            },
            Gold: {
                "Attack": "2.0",
                "HP":"-50"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['gray']
    },
    {
        en: "Houndour",
        zh: "戴鲁比",
        attr: {
            Bronze: {
                "Attack": "1.2",
                "HP":"-30"
            },
            Silver: {
                "Attack": "1.6",
                "HP":"-40"
            },
            Gold: {
                "Attack": "2.0",
                "HP":"-50"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['red']
    },
    {
        en: "Houndoom",
        zh: "黑鲁加",
        attr: {
            Bronze: {
                "Attack": "1.2",
                "Defense":"-3.0"
            },
            Silver: {
                "Attack": "1.6",
                "Defense":"-4.0"
            },
            Gold: {
                "Attack": "2.0",
                "Defense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['red','black']
    },
    {
        en: "Kingdra",
        zh: "刺龙王",
        attr: {
            Bronze: {
                "Speed": "-21.0",
                "SpAttack":"1.8"
            },
            Silver: {
                "Speed": "-28.0",
                "SpAttack":"2.4"
            },
            Gold: {
                "Speed": "-35.0",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue','navy']
    },
    {
        en: "Phanpy",
        zh: "小小象",
        attr: {
            Bronze: {
                "HP": "-30",
                "Attack":"1.2"
            },
            Silver: {
                "HP": "-40",
                "Attack":"1.6"
            },
            Gold: {
                "HP": "-50",
                "Attack":"2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Donphan",
        zh: "顿甲",
        attr: {
            Bronze: {
                "SpDefense": "-3.0",
                "Attack":"1.2"
            },
            Silver: {
                "SpDefense": "-4.0",
                "Attack":"1.6"
            },
            Gold: {
                "SpDefense": "-5.0",
                "Attack":"2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Porygon2",
        zh: "多边兽2型",
        attr: {
            Bronze: {
                "Attack": "-1.2",
                "SpAttack":"1.8"
            },
            Silver: {
                "Attack": "-1.6",
                "SpAttack":"2.4"
            },
            Gold: {
                "Attack": "-2.0",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Stantler",
        zh: "惊角鹿",
        attr: {
            Bronze: {
                "SpDefense": "-3.0",
                "SpAttack":"1.8"
            },
            Silver: {
                "SpDefense": "-4.0",
                "SpAttack":"2.4"
            },
            Gold: {
                "SpDefense": "-5.0",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Smeargle",
        zh: "图图犬",
        attr: {
            Bronze: {
                "HP": "30",
                "SpAttack":"-1.8"
            },
            Silver: {
                "HP": "40",
                "SpAttack":"-2.4"
            },
            Gold: {
                "HP": "50",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Tyrogue",
        zh: "无畏小子",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpDefense":"3.0"
            },
            Silver: {
                "HP": "-40",
                "SpDefense":"4.0"
            },
            Gold: {
                "HP": "-50",
                "SpDefense":"5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Hitmontop",
        zh: "战舞郎",
        attr: {
            Bronze: {
                "SpDefense": "3.0",
                "SpAttack":"-1.8"
            },
            Silver: {
                "SpDefense": "4.0",
                "SpAttack":"-2.4"
            },
            Gold: {
                "SpDefense": "5.0",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Smoochum",
        zh: "迷唇娃",
        attr: {
            Bronze: {
                "HP": "-30",
                "SpAttack":"1.8"
            },
            Silver: {
                "HP": "-40",
                "SpAttack":"2.4"
            },
            Gold: {
                "HP": "-50",
                "SpAttack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['purple']
    },
    {
        en: "Elekid",
        zh: "电击怪",
        attr: {
            Bronze: {
                "HP": "-30",
                "Attack":"1.2"
            },
            Silver: {
                "HP": "-40",
                "Attack":"1.6"
            },
            Gold: {
                "HP": "-50",
                "Attack":"2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['yellow']
    },
    {
        en: "Magby",
        zh: "鸭嘴宝宝",
        attr: {
            Bronze: {
                "Defense": "-3.0",
                "Attack":"1.2"
            },
            Silver: {
                "Defense": "-4.0",
                "Attack":"1.6"
            },
            Gold: {
                "Defense": "-5.0",
                "Attack":"2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['red']
    },
    {
        en: "Miltank",
        zh: "大奶罐",
        attr: {
            Bronze: {
                "Defense": "3.0",
                "SpAttack":"-1.8"
            },
            Silver: {
                "Defense": "4.0",
                "SpAttack":"-2.4"
            },
            Gold: {
                "Defense": "5.0",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Blissey",
        zh: "幸福蛋",
        attr: {
            Bronze: {
                "HP": "30",
                "Attack":"-1.2"
            },
            Silver: {
                "HP": "40",
                "Attack":"-1.6"
            },
            Gold: {
                "HP": "50",
                "Attack":"-2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white']
    },
    {
        en: "Raikou",
        zh: "雷公",
        attr: {
            Bronze: {
                "HP": "30",
                "Attack":"-1.2"
            },
            Silver: {
                "HP": "40",
                "Attack":"-1.6"
            },
            Gold: {
                "HP": "50",
                "Attack":"-2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['yellow']
    },
    {
        en: "Entei",
        zh: "炎帝",
        attr: {
            Bronze: {
                "HP": "30",
                "SpAttack":"-1.8"
            },
            Silver: {
                "HP": "40",
                "SpAttack":"-2.4"
            },
            Gold: {
                "HP": "50",
                "SpAttack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['red']
    },
    {
        en: "Suicune",
        zh: "水君",
        attr: {
            Bronze: {
                "HP": "30",
                "Attack":"-1.2"
            },
            Silver: {
                "HP": "40",
                "Attack":"-1.6"
            },
            Gold: {
                "HP": "50",
                "Attack":"-2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['blue']
    },
    {
        en: "Larvitar",
        zh: "幼基拉斯",
        attr: {
            Bronze: {
                "HP": "30",
                "SpDefense":"-3.0"
            },
            Silver: {
                "HP": "40",
                "SpDefense":"-4.0"
            },
            Gold: {
                "HP": "50",
                "SpDefense":"-5.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Pupitar",
        zh: "沙基拉斯",
        attr: {
            Bronze: {
                "HP": "30",
                "Speed":"-21.0"
            },
            Silver: {
                "HP": "40",
                "Speed":"-28.0"
            },
            Gold: {
                "HP": "50",
                "Speed":"-35.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown']
    },
    {
        en: "Tyranitar",
        zh: "班吉拉斯",
        attr: {
            Bronze: {
                "HP": "30",
                "CriticalRate":"-0.3"
            },
            Silver: {
                "HP": "40",
                "CriticalRate":"-0.5"
            },
            Gold: {
                "HP": "50",
                "CriticalRate":"-0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['brown','black']
    },
    {
        en: "Lugia",
        zh: "洛奇亚",
        attr: {
            Bronze: {
                "SpAttack": "2.7",
                "Attack":"-1.8"
            },
            Silver: {
                "SpAttack": "3.6",
                "Attack":"-2.4"
            },
            Gold: {
                "SpAttack": "4.5",
                "Attack":"-3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white','green']
    },
    {
        en: "Ho-Oh",
        zh: "凤王",
        attr: {
            Bronze: {
                "SpAttack": "-2.7",
                "Attack":"1.8"
            },
            Silver: {
                "SpAttack": "-3.6",
                "Attack":"2.4"
            },
            Gold: {
                "SpAttack": "-4.5",
                "Attack":"3.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['white','brown']
    },
    {
        en: "Celebi",
        zh: "时拉比",
        attr: {
            Bronze: {
                "HP": "-30",
                "ColddownReduction":"0.3"
            },
            Silver: {
                "HP": "-40",
                "ColddownReduction":"0.5"
            },
            Gold: {
                "HP": "-50",
                "ColddownReduction":"0.6"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['green','purple']
    },
    {
        en: "Zacian",
        zh: "苍响",
        attr: {
            Bronze: {
                "SpAttack": "-1.8",
                "Attack":"1.2"
            },
            Silver: {
                "SpAttack": "-2.4",
                "Attack":"1.6"
            },
            Gold: {
                "SpAttack": "-3.0",
                "Attack":"2.0"
            },
        },
        sort: ['Bronze', 'Silver', 'Gold'],
        color:['pink','gray']
    },
    {
        en: "Sprigatito",
        zh: "新叶喵",
        attr: {
            platinum: {
                "SpDefense": "-5.0",
                "Speed":"35.0"
            }
        },
        sort: ['platinum'],
        color:['green']
    },
    {
        en: "Floragato",
        zh: "蒂蕾喵",
        attr: {
            platinum: {
                "Defense": "-5.0",
                "Speed":"35.0"
            }
        },
        sort: ['platinum'],
        color:['green']
    },
    {
        en: "Meowscarada",
        zh: "魔幻假面喵",
        attr: {
            platinum: {
                "HP": "-50",
                "Speed":"35.0"
            }
        },
        sort: ['platinum'],
        color:['green','black']
    },
    {
        en: "Miraidon",
        zh: "密勒顿",
        attr: {
            platinum: {
                "HP": "-50",
                "Speed":"35.0"
            }
        },
        sort: ['platinum'],
        color:['yellow','navy']
    }
]

export default badge


// WEBPACK FOOTER //
// ./src/utils/badge.js